import ElementBase from "./ElementBase";
export default class ChartBase extends ElementBase {
    constructor() {
        super();
        this.self = this;
        this.chartType = "";
        this._generateLoadingSpinnerElement = () => {
            const div = document.createElement("div");
            div.classList.add("loading-panel", "loading-panel-inline", "spinner-sm", "spinner-muted-light");
            div.innerHTML = `
                        <div class="loading-panel loading-panel-inline">
                            <div class="loading-panel-content">
                              <div class="loading-panel-icon">
                                <div class="lds-ring">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                                <div class="loading-panel-heading"></div>
                            </div>
                        </div>
                  `;
            return div;
        };
        this._generateTooltipElement = (title) => {
            const span = document.createElement("span");
            span.classList.add("tooltip-icon", "ml-1");
            span.setAttribute("data-toggle", "tooltip");
            span.setAttribute("data-placement", "top");
            span.setAttribute("title", title);
            span.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
                    <path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path>
                </svg>`;
            return span;
        };
        this.hide = () => {
            if (!this.wrapper.classList.contains("hide")) {
                // set element height
                this.wrapper.style.height = this.wrapper.scrollHeight + "px";
                setTimeout(() => {
                    this.wrapper.classList.add("hide");
                }, 0);
            }
        };
        this.show = () => {
            if (this.wrapper.classList.contains("hide")) {
                // set element height
                this.wrapper.style.height = this.wrapper.scrollHeight + "px";
                setTimeout(() => {
                    this.wrapper.classList.remove("hide");
                }, 0);
            }
        };
        // set message
        this.setMessage = (message) => {
            this.message = message;
        };
        // abstract method
        this.updateData = (props) => {
        };
        this._getElements = () => {
            // get all elements
            this.wrapper = this.querySelector("[data-wrapper]");
            this.canvas = this.wrapper.querySelector("canvas");
            if (this.canvas) {
                this.ctx = this.canvas.getContext('2d');
            }
            this.metricElement = this.wrapper.querySelector("[data-metric]");
            this.questionElement = this.wrapper.querySelector("[data-question]");
            this.legendElement = this.wrapper.querySelector("[data-legend]");
            // size
            if (this.large) {
                this.wrapper.classList.add("dashboard-charts--large");
            }
            else if (this.xlarge) {
                this.wrapper.classList.add("dashboard-charts--xlarge");
            }
            else if (this.medium) {
                this.wrapper.classList.add("dashboard-charts--medium");
            }
            // hide
            if (this.hasAttribute("hide")) {
                this.hide();
            }
            // no loading
            if (!this.noLoading) {
                // add loading spinner
                this.wrapper.classList.add("loading-panel-container");
                this.wrapper.appendChild(this._generateLoadingSpinnerElement());
                // get element
                this.loadingPanelSpinnerElement = this.wrapper.querySelector(".loading-panel-icon");
                this.loadingPanelMessageElement = this.wrapper.querySelector(".loading-panel-heading");
                // show loading spinner
                this.loading = true;
            }
            // generate tooltip
            const tooltip = this.tooltip;
            if (!!tooltip) {
                const tooltipElement = this._generateTooltipElement(tooltip);
                this.metricElement.parentElement.append(tooltipElement);
            }
            // set init state
            this.wrapper.setAttribute("data-initiated", "");
        };
    }
    get class() {
        return this.getAttribute("class") || '';
    }
    get noLoading() {
        return this.hasAttribute("no-loading");
    }
    set metric(value) {
        if (this.metricElement) {
            this.metricElement.textContent = (!!value ? value : "");
        }
    }
    get large() {
        return this.hasAttribute("large");
    }
    get medium() {
        return this.hasAttribute("medium");
    }
    get xlarge() {
        return this.hasAttribute("xlarge");
    }
    get tooltip() {
        return this.getAttribute("tooltip");
    }
    get chartName() {
        return this.getAttribute("chart-name");
    }
    set question(value) {
        if (value && this.questionElement) {
            const prefix = this.isQuestionStatment ? "" : "Q. ";
            this.questionElement.textContent = value.length > 0 ? prefix + value : " ";
        }
        if (this.noQuestion) {
            this.questionElement.textContent = " ";
        }
    }
    set description(value) {
        if (value && value.length > 0) {
            this.questionElement.textContent = value;
        }
    }
    set loading(value) {
        if (!this.noLoading) {
            this.loadingPanelSpinnerElement.hidden = false;
            this.wrapper.classList.toggle("loading", value);
            this.loadingPanelMessageElement.hidden = true;
        }
    }
    get loading() {
        return this.wrapper.classList.contains("loading");
    }
    get noQuestion() {
        return this.hasAttribute("noQuestion");
    }
    get isQuestionStatment() {
        return this.hasAttribute("questionStatement");
    }
    // use loading panel as a message box
    // hide loading spinner when message is exist
    set message(message) {
        // show/hide loading panel
        this.wrapper.classList.add("loading");
        this.loadingPanelSpinnerElement.hidden = true;
        this.loadingPanelMessageElement.textContent = message;
        this.loadingPanelMessageElement.hidden = false;
    }
    _setBaseInfo(props) {
        this.metric = props.metric;
        this.question = props.question;
        this.description = props.description;
    }
}
